import { isAxiosError } from "axios";

import { MONITORING_TEMPORARILY_UNAVAILABLE } from "@/constants/monitoring";

/**
 * Returns true when an import error (CNJ or OAB) was caused by the process
 * monitoring outage — i.e. the server response body carries
 * `code: "MONITORING_TEMPORARILY_UNAVAILABLE"`.
 *
 * Works for both error body shapes the server returns:
 *  - CNJ: `{ cases, errors, code }`
 *  - OAB: `{ error, code }`
 */
export const isMonitoringUnavailableError = (error: unknown): boolean => {
  if (!isAxiosError(error)) return false;
  const code = (error.response?.data as { code?: unknown } | undefined)?.code;
  return code === MONITORING_TEMPORARILY_UNAVAILABLE;
};
